function attach_e_learning(appointmentId) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/e-learning/' + appointmentId + '/view-for-students',
        onOpen: function (elm, popup) {
            const screens = {
                overview: elm.find('.sub-screen-wrapper#overview'),
                attach: elm.find('.sub-screen-wrapper#attach'),
            };



            elm.on('openTab', function(event, link) {
                if (link === 'attach') {
                    let licenses = [];
                    const table = screens.attach.find('table');
                    const form = screens.attach.find('form');
                    const courseSelector = screens.attach.find('select#e_course');
                    const eLearningLicenseCreationCallout = screens.attach.find('#student-count').parents('.callout');

                    // Handle table reloading
                    table.bind('onReload', function() {
                        $('body').isLoading();
                        reload_location_if_needed(false);
                    })

                    if (courseSelector.val() === '0') {
                        // Collect all licenses that are already active, and set the course to the one that's been selected most
                        const courseCountCollection = {};
                        table.find('tr:has(input[name=student_ids\\[\\]][disabled])').each(function() {
                            const tr = $(this);
                            const license = JSON.parse(atob(tr.attr('data-license')));
                            if (!license) return;
                            _.set(courseCountCollection, license.course_code, (_.get(courseCountCollection, license.course_code, 0) + 1))
                        })
                        const sortable = Object.fromEntries(
                            Object.entries(courseCountCollection).sort(([,a],[,b]) => a-b).reverse()
                        );
                        const keys = Object.keys(sortable);
                        if (keys[0]) {
                            courseSelector.val(keys[0]);
                        }
                    }

                    const triggerFooter = () => {
                        const value = courseSelector.val();

                        if (value === '0') return;

                        const data = form.serializeJSON();
                        const newLicenses = (data.student_ids ? data.student_ids : []).filter((studentId) => {
                            // newLicenses are licenses that cannot be found in the list of existing licenses that are also still active
                            return !licenses.find((license) => {
                                return license.contact_id === parseInt(studentId) && license.active;
                            })
                        });


                        if (data.student_ids) {
                            screens.attach.find('input[type="submit"]').removeAttr('disabled');
                        }

                        if (newLicenses.length > 0) {
                            const course = JSON.parse(atob(courseSelector.find('option[value="' + value + '"]').attr('data-value')));
                            eLearningLicenseCreationCallout.show();
                            screens.attach.find('#student-count').html(newLicenses.length);
                            screens.attach.find('#chosen-course').html(course.description);
                            screens.attach.find('#chosen-course-price').html($.number((course.price * newLicenses.length), 2, ",", "."));
                            screens.attach.find('#show-if-not-1-student').toggle(newLicenses.length !== 1);
                        } else {
                            eLearningLicenseCreationCallout.hide();
                        }
                    }

                    const createLicenseRowCallout = (tr, license, attached) => {
                        let rawEndDate = license.license_data.EndDate;
                        if (!rawEndDate) {
                            rawEndDate = license.license_data.endDate;
                        }
                        if (!rawEndDate) {
                            rawEndDate = license.license_data.end_date;
                        }
                        const endDate = moment(rawEndDate);
                        const expired = license.expired;

                        if (attached) {
                            if (expired) {
                                tr.trCallout(`
                                                <p>Gekoppeld aan licentie voor cursus <em>${license.course.description}</em>, welke verliep op <b>${endDate.format('DD-MM-YYYY')}</b> en was ${license.isCompleted ? `afgerond met een ${license.grade}` : '<b>niet</b> afgerond'}.</p>
                                                <p><a class="detach-button">Ontkoppelen</a> | <a class="renew-button">Licentie vernieuwen</a></p>`)
                            } else {
                                tr.trCallout(`
                                                <p>Gekoppeld aan licentie voor cursus <em>${license.course.description}</em> die geldig is tot <b>${endDate.format('DD-MM-YYYY')}</b> (${license.isCompleted ? `afgerond met een ${license.grade}` : 'nog <b>niet</b> afgerond'}).</p>
                                                <p><a class="detach-button">Ontkoppelen</a> | <a class="send-email">Verstuur inloglink</a> | <a class="renew-button">Licentie vernieuwen</a></p>`);
                            }
                        } else {
                            if (expired) {
                                tr.trCallout(`
                                                <p>De bestaande licentie voor deze cursist is verlopen op <b>${endDate.format('DD-MM-YYYY')}</b> en was ${license.isCompleted ? `afgerond met een ${license.grade}` : '<b>niet</b> afgerond'}. Er moet een nieuwe licentie worden gemaakt.</p>`)
                            } else {
                                tr.trCallout(`
                                                <p>Deze cursist heeft een licentie voor deze cursus die geldig is tot <b>${endDate.format('DD-MM-YYYY')}</b> (${license.isCompleted ? `afgerond met een ${license.grade}` : 'nog <b>niet</b> afgerond'}).<br />
                                                   Bij opslaan zal geen nieuwe licentie worden gemaakt, de licentie zal enkel aan deze planning worden gekoppeld.</p>
                                                <p><a class="send-email">Verstuur inloglink</a> | <a class="renew-button">Licentie vernieuwen</a></p>`);
                            }
                        }


                        tr.find('.renew-button').click(async function(e) {
                            e.preventDefault();
                            await renew_elearning_license(license.id, true);
                            reload_location_if_needed(false);
                        });
                        tr.find('.detach-button').click(async function(e) {
                            e.preventDefault();
                            await detach_elearning_license(license.id, appointmentId);
                            reload_location_if_needed(false);
                        });
                        tr.find('.send-email').click(async function(e) {
                            e.preventDefault();
                            await send_elearning_link(license.id, appointmentId);
                        });
                    }

                    table.find('input[name=student_ids\\[\\]]').unbind('change').change(function() {
                        triggerFooter();
                    });

                    table.find('input[name=student_ids\\[\\]]').unbind('disabled').bind('disabled', function() {
                        const tr = $(this).parents('tr');
                        if (tr.is('[data-email-invalid]')) {
                            tr.trCallout('Deze persoon heeft geen correct emailadres in het systeem staan en kan niet gekoppeld worden.', 'alert')
                            return;
                        }
                        const license = JSON.parse(atob(tr.attr('data-license')));
                        createLicenseRowCallout(tr, license, true);
                    });
                    table.find('input[name=student_ids\\[\\]][disabled]').trigger('disabled');

                    courseSelector.unbind('change').change(async function() {

                        screens.attach.find('input[type="submit"]').attr('disabled', 'disabled');

                        const value = courseSelector.val();

                        table.find('tr:has(.tr-callout):not(:has(input[disabled]))').trCallout(false);
                        if (value === '0') {
                            eLearningLicenseCreationCallout.hide();
                            return;
                        }


                        const contact_ids = table.find('input[name=student_ids\\[\\]]:not([disabled])').toArray().map((input) => jQuery(input).val());
                        licenses = await $.get(`/e-learning/getElearningLicensesForCourse/${value}`, {contact_ids});

                        // Tell the user which licenses are already active
                        licenses.forEach((license) => {
                            const tr = table.find(`tr[data-id=${license.contact_id}]:not(:has(input[disabled]))`);
                            if (tr.length === 0) {
                                return;
                            }
                            createLicenseRowCallout(tr, license, false);
                        });

                        $(this).find('option[value="0"]').remove();


                        triggerFooter();

                    }).trigger('change');

                    form.ajaxFormSubmit(function() {
                        const data = form.serializeJSON();
                        squde_flash(data.student_ids.length + ' cursist' + (data.student_ids.length === 1 ? '': 'en') + ' met succes gekoppeld aan de E-Learning.');
                        $('body').doneLoading();
                        reload_location_if_needed(document.closeWindow);
                    }.bind([elm,popup]), function(xhr, status, error) {
                        $('body').doneLoading();
                        squde_flash('Er ging iets mis bij het opslaan.', 'alert');
                    }.bind([elm,popup]),function() {
                        $('body').isLoading('dark');
                    });
                }
            });

        }
    });
    return false;
}

function view_elearning_grades(license_id) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/e-learning/license/' + license_id + '/grades',
        onOpen: function (elm, popup) {
            const table = elm.find('table');

        },
        onError: (error) => {
            try {
                const message = error.responseJSON.error;
                if (message === 'Grades not found...') {
                    squde_flash('Licentie lijkt niet meer actief', 'alert');
                } else {
                    console.error({error});
                }
            } catch (e) {
                console.error({e});
            }
        }
    });
    return false;
}

function view_elearning_license(id, vars) {
    const $ = jQuery.noConflict();

    if(typeof vars === 'function') {
        vars = {callback: vars};
    }

    $.squdeAjaxPopup({
        url: `/e-learning/license/${id}`,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('elearninglicense', id);
                $('body').doneLoading();
                squde_reload_for_flashes();
                if (document.closeWindow) popup.close();
                if(vars && vars.callback) {
                    vars.callback(data, elm, popup);
                }
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function delete_elearning_license(id) {
    custom_delete_with_confirmation(`/e-learning/license/${id}`,id,`Weet u zeker dat u deze licentie wilt verwijderen?<br />Let op: Deze licentie moet nog apart worden verwijderd bij uw ELearning partij.`,'elearninglicense', squde_reload_for_flashes, undefined, 'DELETE');

    return false;
}

function create_elearning_license(contact_id) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: `/e-learning/create/${contact_id}`,
        onOpen: function (elm, popup) {
            elm.find('form').ajaxFormSubmit(function(license){
                popup.close();
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(false);
                if (!document.closeWindow) open_new_object(view_elearning_license, license.id);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function renew_elearning_license(license_id, returnPromise = false) {
    const $ = jQuery.noConflict();

    const promise = new Promise((resolve, reject) => {
        confirm("Weet u zeker dat u deze licentie wilt vernieuwen?<br />Hier kunnen kosten aan verbonden zijn.", function() {
            $('body').isLoading('dark');

            $.ajax({
                url: `/e-learning/license/${license_id}/renew`,
                type: 'POST',
                success: function(data) {
                    $('body').doneLoading();
                    squde_reload_for_flashes();
                    updateObject('elearninglicense', data.id);
                    resolve(data);
                },
                error: function(e) {
                    $('body').doneLoading();
                    squde_flash("Er ging helaas iets mis.", "alert");
                    reject(e);
                }
            });
        });
    });
    if (returnPromise) {
        return promise;
    }
    return false;
}

function detach_elearning_license(license_id, appointment_id) {
    const $ = jQuery.noConflict();

    return new Promise((resolve, reject) => {
        confirm("Weet u zeker dat u deze licentie wilt ontkoppelen van deze planning?<br />De licentie zal actief blijven.", function() {
            $('body').isLoading('dark');

            $.ajax({
                url: `/e-learning/license/${license_id}/${appointment_id}/detach`,
                type: 'POST',
                success: function(data) {
                    $('body').doneLoading();
                    squde_reload_for_flashes();
                    resolve(data);
                },
                error: function(e) {
                    $('body').doneLoading();
                    squde_flash("Er ging helaas iets mis.", "alert");
                    reject(e);
                }
            });
        });
    });
}

function send_elearning_link(license_id, appointment_id) {
    const $ = jQuery.noConflict();

    return new Promise((resolve, reject) => {
        $('body').isLoading('dark');

        $.ajax({
            url: `/e-learning/license/${license_id}/${appointment_id}/send-link`,
            type: 'POST',
            success: function() {
                $('body').doneLoading();
                squde_reload_for_flashes();
                resolve();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
                reject(e);
            }
        });
    });
}

function view_elearning_course(code) {
    const $ = jQuery.noConflict();
    $.squdeAjaxPopup({
        url: '/e-learning/courses/' + code,
        onOpen: function(elm, popup) {

            elm.find('[data-product-selector]').productSelector();

            elm.find('form').ajaxFormSubmit(function(data){
                squde_reload_for_flashes();

                $('body').doneLoading();
                reload_location_if_needed(document.closeWindow);
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]),function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

function make_elearning_invoices() {
    const $ = jQuery.noConflict();
    const selection = window['selected_e_learning_licenses'];
    const length = selection.length;

    confirm(`Weet u zeker dat u deze ${length === 1 ? 'licentie' : `${length} licenties`} wilt factureren?`, function() {
        $('body').isLoading();
        $.ajax({
            url: '/e-learning/licenses/makeInvoices',
            type: 'POST',
            data: {
                licenses: selection
            },
            success: function() {
                $('body').doneLoading();
                squde_reload_for_flashes();
                reload_location_if_needed(false);
            },
            error: function() {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}

function send_elearning_license_confirmation(license_id) {
    const $ = jQuery.noConflict();

    confirm("Weet u zeker dat u deze link wilt versturen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: `/e-learning/license/${license_id}/send-link`,
            type: 'POST',
            success: function() {
                $('body').doneLoading();
                squde_reload_for_flashes();
            },
            error: function() {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });

    return false;
}
